import { createOptionsRange } from "./createoptionsRangeCapital";

export interface CapitalsI {
  minCapital?: number;
  maxCapital?: number;
  min?: number;
  max?: number;
  availableTraits: {
    DEATH: boolean;
    DISABILITY: boolean;
  };
}

export type PrepareCapitalsProps = {
  capitals: CapitalsI;
};

const prepareCapitals = ({ capitals }: PrepareCapitalsProps) => {
  const maxCapital = capitals.maxCapital ?? capitals.max;
  const minCapital = capitals.minCapital ?? capitals.min;
  const stepper = {
    50000: 5000,
    100000: 10000
  }[maxCapital] || 50000;
  const options = createOptionsRange({
    maxCapital: maxCapital,
    minCapital: minCapital,
    step: stepper,
  });

  let indexPreSelected = Math.round(options.length / 2) - 1;
  if(maxCapital === 50000) {
    indexPreSelected = Math.round(options.length / 2) - 2;
  }
  if(maxCapital === 100000 || maxCapital === 180000) {
    indexPreSelected = 0;
  }
  console.log('maxCapital', maxCapital)
  return { options, indexPreSelected };
};

export default prepareCapitals;
